import { billing, getConfig, readAccessToken } from '@repletoryreach/sdk-api';
import type { RemoteFileSource } from '@repletoryreach/sdk-ui/file-viewer';
import type { Translate } from '../../i18n/I18nProvider';
import { formatDateTime, formatMinor } from '../../lib/format';

/**
 * An invoice PDF as the file viewer wants it.
 *
 * The old link pointed a browser navigation at an authenticated endpoint, so
 * it answered 401 for everyone: a navigation carries no bearer token. The
 * viewer fetches the PDF with the session's token instead, and because that
 * URL only works with the token on the request there is no shareable link.
 */
export function invoiceViewerSource(inv: billing.Invoice, t: Translate): RemoteFileSource {
  const cfg = getConfig();
  const token = readAccessToken();
  return {
    kind: 'remote',
    id: inv.id,
    url: `${cfg.apiBaseUrl}${billing.invoicePdfUrl(inv.id)}`,
    name: `${inv.invoice_number}.pdf`,
    mime: 'application/pdf',
    headers: token ? { authorization: `Bearer ${token}` } : {},
    credentials: cfg.http.credentials,
    linkUrl: null,
    title: inv.invoice_number,
    details: [
      { label: t('common.status'), value: t(`billing.invoiceStatus.${inv.status}`, inv.status) },
      { label: t('common.total'), value: formatMinor(inv.total_minor, inv.currency) },
      { label: t('billing.invoices.issuedAt'), value: inv.issued_at ? formatDateTime(inv.issued_at) : t('billing.invoices.notIssued') }
    ]
  };
}
